import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { PhotoManager } from "@/components/admin/PhotoManager";
import { VideoUploader } from "@/components/admin/VideoUploader";
import { API, apiError, authHeaders } from "@/lib/api";

const FIELDS = [
  ["homeEyebrow", "Home — scritta piccola in alto"],
  ["homeHeadline", "Home — titolo principale"],
  ["ctaLabel", "Home — scritta sul bottone evento"],
  ["tavoliLabel", "Home — scritta sopra il numero"],
  ["prenotaEyebrow", "Prenota — scritta sopra la data"],
  ["prenotaSubline", "Prenota — scritta sotto la data"],
  ["successTitle", "Prenota — titolo dopo la prenotazione"],
  ["soldOutTitle", "Prenota — titolo quando è al completo"],
];

const Heading = ({ children, hint }) => (
  <div className="flex flex-col gap-1">
    <h3 className="font-heading italic text-white text-2xl tracking-[-0.5px]">{children}</h3>
    {hint && <p className="text-xs text-white/45">{hint}</p>}
  </div>
);

export const ContentPanel = ({ config, onSaved }) => {
  const [draft, setDraft] = useState({ texts: config.texts, formBgImages: config.formBgImages, heroVideo: config.heroVideo });
  const [saving, setSaving] = useState(false);

  const save = async (next = draft) => {
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/admin/content`, next, { headers: authHeaders() });
      onSaved(data);
      toast.success("Contenuti salvati");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  const setVideo = (url) => {
    const next = { ...draft, heroVideo: url };
    setDraft(next);
    save(next);
  };

  return (
    <section className="glass-strong rounded-[1.5rem] p-6 md:p-8 flex flex-col gap-8" data-testid="admin-content-panel">
      <h2 className="font-heading italic text-white text-3xl tracking-[-1px]">Contenuti del sito</h2>
      <div className="grid md:grid-cols-2 gap-x-6 gap-y-4">
        {FIELDS.map(([key, label]) => (
          <label key={key} className="flex flex-col gap-2">
            <span className="text-xs uppercase tracking-[0.12em] text-white/60 font-medium">{label}</span>
            <input data-testid={`admin-text-${key}`} className="glass-input" value={draft.texts[key] || ""}
              onChange={(e) => setDraft((d) => ({ ...d, texts: { ...d.texts, [key]: e.target.value } }))} />
          </label>
        ))}
      </div>
      <div className="grid lg:grid-cols-[260px_1fr] gap-8">
        <div className="flex flex-col gap-4">
          <Heading hint="Video di sfondo della home. Si salva da solo appena è pronto.">Video home</Heading>
          <VideoUploader value={draft.heroVideo} onChange={setVideo} />
        </div>
        <div className="flex flex-col gap-4 min-w-0">
          <Heading hint="Sfondo della pagina Prenota: scorrono in quest'ordine. Usa le frecce per riordinarle.">Foto Prenota</Heading>
          <PhotoManager value={draft.formBgImages} onChange={(v) => setDraft((d) => ({ ...d, formBgImages: v }))} />
        </div>
      </div>
      <button onClick={() => save()} disabled={saving} data-testid="admin-save-content"
        className="bg-white text-black rounded-full px-6 py-3 text-sm font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity disabled:opacity-60 md:self-end md:min-w-[240px]">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salva titoli e foto"}
      </button>
    </section>
  );
};
